import {
    FETCH_DATA_PRODUCTS_REQUEST,
    FETCH_DATA_PRODUCTS_SUCCESS,
    FETCH_DATA_PRODUCTS_FAILURE,
} from '../../actions/products/get-products-actions';

const initialState = {
    list: [],
    isLoading: false,
    error: null,
    meta: null
};

const ProductReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DATA_PRODUCTS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DATA_PRODUCTS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                list: action.payload.values,
                meta: action.payload.meta
            };
        case FETCH_DATA_PRODUCTS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default ProductReducer;